module.exports = __webpack_public_path__ + "img/bus-a.5133281e.png";